import { Component, Inject, OnInit } from '@angular/core';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { UiConfig } from '@freelancer/ui/ui.interface';

@Component({
  selector: 'webapp-compat-navigation-empty',
  template: `
    <app-navigation-empty [transparent]="transparent" [darkMode]="darkMode">
    </app-navigation-empty>
  `,
})
export class CompatNavigationEmptyComponent implements OnInit {
  transparent: boolean;
  darkMode: boolean;

  constructor(@Inject(UI_CONFIG) private uiConfig: UiConfig) {}

  ngOnInit() {
    // Note: this is a hack for allowing us to set transparent navigation
    // if the PHP template variable transparent_header is set to true.
    if ((window as any).webappCompat['navigation-empty']) {
      this.transparent = (window as any).webappCompat[
        'navigation-empty'
      ].transparent;
    }
    this.darkMode = this.uiConfig.theme === 'arrow';
  }
}
